export const parseJSON = (value, fallback = null) => {
  try {
    return value ? JSON.parse(value) : fallback;
  } catch {
    return fallback;
  }
};

export const canAccess = (permissions = [], permission) => {
  if (!Array.isArray(permissions)) return false;

  if (Array.isArray(permission)) {
    return permission.some((item) => permissions.includes(item));
  }

  return permissions.includes(permission);
};
